/**
 * How run states, outcomes and payload scalars read on the page: the tag
 * tone for a state word, its human label, and a payload scalar's display.
 */

export function toneFor(value: string): 'success' | 'warning' | 'error' | 'info' {
  if (
    ['READY', 'SUCCEEDED', 'APPROVED', 'CONFIRMED', 'STRONG_MATCH', 'HIGH'].includes(
      value,
    )
  )
    return 'success';
  if (['NOT_READY', 'FAILED', 'REJECTED', 'LOW'].includes(value)) return 'error';
  if (['NEEDS_REVIEW', 'PARTIAL', 'AWAITING_REVIEW'].includes(value)) {
    return 'warning';
  }
  return 'info';
}

export function humanState(value: string): string {
  const labels: Readonly<Record<string, string>> = {
    SUCCEEDED: 'Completed successfully',
    AWAITING_REVIEW: 'Awaiting Owner review',
    INSUFFICIENT_EVIDENCE: 'Not enough evidence to recommend action',
    FEATURE_RELATIVE_MEASUREMENT_ASSOCIATION:
      'Observed content-performance association',
  };
  return labels[value] ?? value.replaceAll('_', ' ').toLowerCase();
}

export function displayScalar(value: unknown, fallback: string): string {
  return typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
    ? String(value)
    : fallback;
}
